import React from 'react'
import { Segment, Grid, Icon, Button } from 'semantic-ui-react';

const StudentDetailedInfo = () => {
    return (
        <Segment.Group>
            <Segment attached='top'>
                <Grid>
                    <Grid.Column width={1}>
                        <Icon size='large' color='teal' name='info' />
                    </Grid.Column>
                    <Grid.Column width={15}>
                        <p>description of event</p>
                    </Grid.Column>
                </Grid>
            </Segment>
            <Segment>
                <Grid verticalAlign='middle'>
                    <Grid.Column width={1}>
                        <Icon name='calendar' size='large' color='teal' />
                    </Grid.Column>
                    <Grid.Column>
                        <span>Event Date</span>
                    </Grid.Column>
                </Grid>
            </Segment>
            <Segment>
                <Grid verticalAlign='middle'>
                    <Grid.Column width={1}>
                        <Icon name='marker' size='large' color='teal' />

                    </Grid.Column>
                    <Grid.Column width={11}>
                        <span>Event Venue</span>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Button color='teal' size='tiny' content='show map' />
                    </Grid.Column>
                </Grid>
            </Segment>
        </Segment.Group>
    )
}

export default StudentDetailedInfo
